export function formatMainWalletAmountDisplay(
  value: number | string | null | undefined,
  maxIntegerDigits = 6,
): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) {
    return "0.00";
  }

  const abs = Math.abs(n);
  const intPart = Math.floor(abs);
  const intStr = intPart.toString(10);

  if (intStr.length <= maxIntegerDigits) {
    return abs.toFixed(2);
  }

  return `${intStr.slice(0, maxIntegerDigits)}...`;
}
